import { createReducer, createAPI } from 'rex';
import { connect } from 'rex/lib/react-rex';
import { createStore } from 'redux';
import triggers from './triggers';
import handlers from './handlers';

const reducer = createReducer(handlers);
const store = createStore(reducer);
const api = createAPI(store, triggers, { connect });

export default api;



// WEBPACK FOOTER //
// ./src/frontend/api.js